import React from "react";
import { backIcon } from "../../SvgIcon";

export default function Previous({ baseSlug = "all-pages", current = 1, assets = "" }) {

    return (
        <>
            {current > 1 ? (
                <a
                    href={`#/${baseSlug}/page/${parseInt(current) - 1}`}
                    className="flex text-ec-title font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-md hover:border-ec-primary hover:text-ec-primary transition-colors duration-200 active:text-ec-primary focus:text-ec-primary"
                >
                    <div className="text-ec-primary">
                        {backIcon}
                    </div>
                    <span>Back</span>
                </a>
            ) : (
                <div className="flex text-ec-disabled font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-md cursor-not-allowed opacity-50">
                    <div>
                        {backIcon}
                    </div>
                    <span>Back</span>
                </div>
            )}
        </>
    );
}